import { enumItems } from './enumItems';
import { enumItemsWithColor } from './enumItemsWithColor';
import { statuses } from './statuses';
import { group } from './group';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { Group } from '../types/entities/Group';
import { NumberField } from '../components/Table/fields/NumberField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { TextField } from '../components/Table/fields/TextField';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { salesPartner } from './salesPartner';
import { roomType } from './roomType';
import { SelectFieldWithoutAutocomplete } from '../components/Table/fields/SelectFieldWithoutAutocomplete';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPBooleanField } from '../components/Table/fields/SPBooleanField';
import { accommodation } from './accommodation';
import {SPSelectWithOutAutocomplete} from "../components/Table/fields/SPSelectWithOutAutocompleteField";
import {SPTimeField} from "../components/Table/fields/SPTimeField";
import {FileField} from "../components/Table/fields/FileField";
import {SingleFileField} from "../components/Table/fields/SingleFileField";

export const accommodationReservation = (
  forGroupId?: Group['id']
): SchemaWithClient<any> => ({
  name: 'Accommodation Reservation',
  pluralName: 'Accommodation',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      required: false,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      readOnly: true,
      hide: true,
    },
    accommodation: {
      name: 'Accommodation',
      required: false,
      fieldRenderer: SelectField.tableAdapter(accommodation),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(accommodation),
      url: accommodation.client.getAllPath,
      tempSchema: accommodation,
      switchboard: true,
    },
    group: {
      name: 'Group',
      required: false,
      fieldRenderer: SelectField.tableAdapter(group),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(group),
      switchboard: true,
      readOnly: true,
      url: group.client.getAllPath,
      tempSchema: group,
      width: 'small',
    },
    reservation_type: {
      name: 'Type',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceReservationType),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.serviceReservationType
      ),
      url: enumItems.serviceReservationType.client.getAllPath,
      tempSchema: enumItems.serviceReservationType,
      switchboard: true,
    },
    reservation_status: {
      name: 'Status',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.serviceReservationStatus
      ),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        statuses.serviceReservationStatus
      ),
      url: statuses.serviceReservationStatus.client.getAllPath,
      tempSchema: statuses.serviceReservationStatus,
      switchboard: true,
      width: 'medium',
      editOnlyByAdmin: true
    },
    booked_by: {
      name: 'Booked By',
      fieldRenderer: SelectField.tableAdapter(enumItemsWithColor.bookedBy),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItemsWithColor.bookedBy
      ),
      url: enumItemsWithColor.bookedBy.client.getAllPath,
      tempSchema: enumItemsWithColor.bookedBy,
      switchboard: true,
      width: 'medium',
    },
    arrival: {
      name: 'Arrival',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'medium',
      collapseHeader: true,
    },
    departure: {
      name: 'Departure',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'medium',
      collapseHeader: true,
    },
    checkin_time: {
      name: 'Checkin Time',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
    },
    checkout_time: {
      name: 'Checkout Time',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
    },
    send_docs: {
      name: 'Send Docs',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    confirms: {
      name: 'Confirmation File',
      fieldRenderer: FileField,
      slidePaneFieldRenderer: FileField,
      fieldType: 'file',
    },

    sales_partner: {
      name: 'Sales Partner',
      fieldRenderer: SelectField.tableAdapter(salesPartner),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(salesPartner),
      switchboard: true,
      url: salesPartner.client.getAllPath,
      tempSchema: salesPartner,
    },
    size: {
      name: 'Size',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      collapseHeader: true,
    },

    room_type: {
      name: 'Room Type',
      fieldRenderer: SelectField.tableAdapter(roomType),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(roomType),
      url: roomType.client.getAllPath,
      tempSchema: roomType,
      switchboard: true,
      width: 'medium',
    },
    number_of_rooms: {
      name: 'Number of Rooms',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'medium',
    },

    breakfast_included: {
      name: 'Breakfast Included',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },

    deposit_amount: {
      name: 'Deposit Amount',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'small',
    },
    deposit_deadline: {
      name: 'Deposit Deadline',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'small',
    },
    deposit_paid: {
      name: 'Deposit Paid',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'small',
    },
    full_amount: {
      name: 'Full Amount',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'small',
    },
    full_amount_deadline: {
      name: 'Full Amount Deadline',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'small',
    },
    full_amount_paid: {
      name: 'Full Amount Paid',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'small',
    },
    damage_deposit: {
      name: 'Damage Deposit',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },

    total_cost: {
      name: 'Total Gross Cost',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    gross_cost_person_night: {
      name: 'Gross Cost Person/Night',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'extra-small',
    },
    cost_ifa_percent: {
      name: 'Cost IFA Percent',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      required: true,
    },
    cost_vat_percent: {
      name: 'Cost VAT Percent',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      required: true,
    },
    cost_currency: {
      name: 'Cost Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(enumItems.currency),
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      switchboard: true,
      width: 'extra-small',
    },

    total_price: {
      name: 'Total Gross Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    sales_price_person_night: {
      name: 'Sales Price Person/Night',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'small',
    },
    price_vat_percent: {
      name: 'Price VAT Percent',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'small',
    },
    price_currency: {
      name: 'Price Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      switchboard: true,
      width: 'small',
    },

    guide_notes: {
      name: 'Guide Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    office_notes: {
      name: 'Office Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    group_notes: {
      name: 'Group Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
      width: 'small',
    },
  },
  client: new Client(
    '/accommodation-reservations',
    forGroupId !== undefined
      ? `/groups/${forGroupId}/accommodation-reservations`
      : undefined
  ),
  viewTable: 'accommodation_reservations',
});
